import React, {memo, useMemo} from "react";

const BackgroundLetters = memo(({count = 28}) => {
    const lettersData = useMemo(() => {
        const letters = "АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЭЮЯ".split("");

        const generated = Array.from({ length: count }).map(() => ({
            char: letters[Math.floor(Math.random() * letters.length)],
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            rotate: Math.random() * 360,
            fontSize: 40 + Math.random() * 40,
            opacity: 0.02 + Math.random() * 0.08,
            duration: `${24 + Math.random() * 20}s`,
            delay: `${Math.random() * -20}s`,
            driftX: `${-20 - Math.random() * 30}px`,
            driftY: `${20 + Math.random() * 30}px`,
        }));

        return generated;
    }, [count]);

    return (
        <div
            className="app-background-letters"
            style={{
                background: "linear-gradient(180deg, var(--app-bg-main), var(--app-bg-main))",
            }}
            aria-hidden="true"
        >
            {lettersData.map((item, i) => (
                <div
                    key={i}
                    className="app-background-letters__item"
                    style={{
                        left: item.left,
                        top: item.top,
                        fontSize: item.fontSize,
                        opacity: item.opacity,
                        "--letter-rotate": `${item.rotate}deg`,
                        "--letter-duration": item.duration,
                        "--letter-delay": item.delay,
                        "--letter-drift-x": item.driftX,
                        "--letter-drift-y": item.driftY,
                    }}
                >
                    {item.char}
                </div>
            ))}
        </div>
    );
});

export default BackgroundLetters;
